import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { Icon } from "semantic-ui-react";

export const callScriptState = {
  minimized: "minimized",
  maximized: "maximized",
};

export default function CallScript({
  name,
  script,
  isPopped,
  setPopped,
  onClose,
}) {
  if (!isPopped) {
    return (
      <div className="call-script call-script-minimized">
        <div className="call-script-heading">
          {name}
          <div className="call-script-buttons">
            <Icon size="window maximize outline" onClick={() => setPopped()} />
          </div>
        </div>
      </div>
    );
  }

  if (isPopped) {
    return (
      <Draggable handle=".call-script-heading">
        <div className="call-script call-script-maximized">
          <div className="call-script-heading">
            {name}
            <div className="call-script-buttons">
              <Icon size="close" onClick={() => onClose()} />
            </div>
          </div>
          <div className="call-script-text">{script}</div>
        </div>
      </Draggable>
    );
  }

  return "";
}
